import cls from 'classnames';
import { Button, ButtonElementTypes, ButtonSizeXL, ButtonSkinPrimary } from '@picsart/button';

import { UploadArea } from '../../core';
import DemoImages from '../image/DemoImages';
import ToolRating from '../ToolRating/ToolRating';

import { UploadLandingProps } from './types';
import useStyles from './styles';

function UploadSection({
  className,
  srcSet,
  src,
  sizes,
  alt,
  title,
  subtitle,
  subtitleTag = 'p',
  uploadDisabled,
  uploadAccept,
  uploadMultiple,
  onUpload,
  uploadText,
  uploadButtonText,
  uploadButtonIcon,
  demoImages,
  demoImagesText,
  onDemoImageClick,
  demoImagesDescription,
  preReviewSection = null,
  review,
  reviewsNumber,
}: UploadLandingProps) {
  const classes = useStyles();
  const Subtitle = subtitleTag;

  return (
    <div className={cls(classes.root, className)}>
      <img className={classes.mainImg} src={src} srcSet={srcSet} sizes={sizes} alt={alt} />
      <h1 className={cls('fs-42', classes.title)}>{title}</h1>
      <Subtitle className={cls('fs-16', classes.subtitle)}>{subtitle}</Subtitle>

      <UploadArea
        className={classes.upload}
        disabled={uploadDisabled}
        accept={uploadAccept}
        multiple={uploadMultiple}
        onUpload={onUpload}
      >
        <p className={cls('fs-16', classes.uploadTxt)}>{uploadText}</p>
        <Button
          tag={ButtonElementTypes.Button}
          size={ButtonSizeXL}
          startIcon={uploadButtonIcon}
          skin={ButtonSkinPrimary}
        >
          {uploadButtonText || 'Select image'}
        </Button>
      </UploadArea>

      <DemoImages
        className={classes.demoImages}
        images={demoImages}
        text={demoImagesText}
        onImageClick={onDemoImageClick}
      />

      {demoImagesDescription && (
        <p className={cls('fs-14', classes.demoImagesSubtitle)}>{demoImagesDescription}</p>
      )}

      {preReviewSection}

      {review && reviewsNumber && (
        <ToolRating review={review} reviewsNumber={reviewsNumber} className={classes.rating} />
      )}
    </div>
  );
}

export default UploadSection;
